import { StorageObject } from "../../../services/api/instances/storageApi/types/object_types";
import { StorageObjectValue } from "../../../services/api/instances/storageApi/types/service_types";

export const updateObjects = <T extends StorageObjectValue>(
  newObject: StorageObject<T>,
  objects: StorageObject<T>[],
): StorageObject<T>[] => {
  return objects.map((item) => {
    if (item.id === newObject.id) {
      return { ...newObject };
    }
    if (item.children) {
      return {
        ...item,
        children: updateObjects(newObject, item.children),
      };
    }
    return { ...item };
  });
};

export const getFilteredObjects = <T extends StorageObjectValue>(
  objects: StorageObject<T>[],
) => {
  const folders = objects
    .filter((object) => object?.value === null)
    .sort((a, b) => (Number(a.id) > Number(b.id) ? 1 : -1));
  const items = objects
    .filter((object) => object?.value !== null)
    .sort((a, b) => (Number(a.id) > Number(b.id) ? 1 : -1));
  return [...folders, ...items];
};

export const getRefTextForJson = (ref?: string) => {
  if (!ref) {
    return "";
  }
  return `${ref.slice(0, 6)}*************${ref.slice(-6)}`;
};

export const getSortedObject = <T extends StorageObjectValue>(
  dialogs: StorageObject<T>[],
) => {
  const sortedDialogs = dialogs.sort((a, b) => {
    const firstId = Number(a.id);
    const secondId = Number(b.id);
    return firstId > secondId ? 1 : -1;
  });
  return sortedDialogs;
};

export const getCountOfObjects = <T extends StorageObjectValue>(
  objects: StorageObject<T>[],
) => {
  const countOfObjects = objects.reduce((acc, object) => {
    if (object?.value !== null) {
      return acc + 1;
    } else {
      const children = object.children?.length || 0;
      return acc + children;
    }
  }, 0);
  return countOfObjects;
};
export const getCountOfFolders = <T extends StorageObjectValue>(
  objects: StorageObject<T>[],
) => objects.filter((object) => object?.value === null).length;
